import { __assign } from "tslib";
import React from "react";
import { getEnv } from "@adsk/acs-sc-web-platform-api";
import { Reset } from "@adsk/alloy-react-theme";
import { CreateTemplateInSettingsModal, } from "./CreateTemplateInSettingsModal";
import { LaunchDarklyIdByEnv } from "../shared/constants";
import { LaunchDarklyProvider } from "../shared/components/LaunchDarklyContext";
import { useAnalytics } from "../hooks/useAnalytics";
import { useOptionalUser } from "@adsk/alloy-provider/es/UserContext";
import { createOnSubmit } from "../shared/sharedCreateProjectTemplateHelpers";
export var CreateTemplateInSettingsModalContainer = function (props) {
    var env = getEnv();
    var track = useAnalytics();
    // Configure API Request - Current User
    var user = useOptionalUser().data;
    var createTemplateInSettingsModalProps = __assign({ onSubmit: createOnSubmit(user, props), track: track }, props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Reset, null),
        React.createElement(LaunchDarklyProvider, { apiKey: LaunchDarklyIdByEnv[env], projectEntitlementsUnavailable: true },
            React.createElement(CreateTemplateInSettingsModal, __assign({}, createTemplateInSettingsModalProps)))));
};
